import React, { createContext, useCallback, useContext, useState } from 'react';

/* ─── context ─────────────────────────────────────────────────────────── */
type PaymentDetailContextType = {
  openPaymentDetail: (txnId: string) => void;
};

const PaymentDetailContext = createContext<PaymentDetailContextType>({
  openPaymentDetail: () => {},
});

/* ─── lazy drawer ─────────────────────────────────────────────────────── */
const PaymentDetailDrawer = React.lazy(
  () => import('../components/PaymentDetailDrawer'),
);

/* ─── provider ────────────────────────────────────────────────────────── */
export function PaymentDetailProvider({ children }: { children: React.ReactNode }) {
  const [txnId, setTxnId]   = useState<string | null>(null);
  const [open, setOpen]     = useState(false);

  const openPaymentDetail = useCallback((id: string) => {
    setTxnId(id);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => setOpen(false), []);

  return (
    <PaymentDetailContext.Provider value={{ openPaymentDetail }}>
      {children}
      <React.Suspense fallback={null}>
        {txnId && (
          <PaymentDetailDrawer
            open={open}
            txnId={txnId}
            onClose={handleClose}
          />
        )}
      </React.Suspense>
    </PaymentDetailContext.Provider>
  );
}

/* ─── hook ────────────────────────────────────────────────────────────── */
export function usePaymentDetail(): PaymentDetailContextType {
  return useContext(PaymentDetailContext);
}
